import TtamCreativeWebsiteUrlCheckUrl from './check-url/index.vue';
import TtamCreativeWebsiteUrlInput from './input/index.vue';
import TtamCreativeWebsiteUrlProductSalesInput from './product-sales-input/index.vue';
import TtamCreativeWebsiteUrlProductSalesWebsiteType from './product-sales-website-type/index.vue';
import TtamCreativeWebsiteUrlProductSalesTips from './product-sales-tips/index.vue';
import TtamCreativeWebsiteUrlRejectReason from './reject-reason/index.vue';
import TtamCreativeUtmEntry from './utm-entry/index.vue';

import * as hooks from './hooks';

export default {
  TtamCreativeWebsiteUrlCheckUrl,
  TtamCreativeWebsiteUrlInput,
  TtamCreativeWebsiteUrlProductSalesInput,
  TtamCreativeWebsiteUrlProductSalesWebsiteType,
  TtamCreativeWebsiteUrlProductSalesTips,
  TtamCreativeWebsiteUrlRejectReason,
  TtamCreativeUtmEntry,
  ...hooks,
};
